/**
 * List of Plans
 */
class Plans {
  static get values() {
    return {
      free: 'free',
      starter: 'starter',
      custom: 'custom',
      basic: 'basic',
      standard: 'standard',
      plus: 'plus',
      pro: 'pro',
    };
  }

  static getCurrentTierInfo(plan: string) {
    return [CUSTOM_PLAN, ...PLANS_TIERS].find(tier => tier.name === plan);
  }
}

export const FEATURES = {
  analytics: 'analytics',
  import: 'import',
  whiteLabel: 'whiteLabel',
  customLabelDesign: 'customLabelDesign',
  catalogPages: 'catalogPages',
  qrCode: 'qr_code',
  eLabels: 'eLabels',
};

export const PLANS_STATUS = [
  {
    value: 'active',
    labelKey: 'plan.status.active',
  },
  {
    value: 'cancel_at_period_end',
    labelKey: 'plan.status.cancel_at_end',
  },
  {
    value: 'past_due',
    labelKey: 'plan.status.past_due',
  },
  {
    value: 'unpaid',
    labelKey: 'plan.status.unpaid',
  },
  {
    value: 'paused',
    labelKey: 'plan.status.paused',
  },
  {
    value: 'canceled',
    labelKey: 'plan.status.canceled',
  },
  {
    value: 'error',
    labelKey: 'plan.status.error',
  },
];

export const CUSTOM_PLAN = {
  name: Plans.values.custom,
  producersNumber: 2,
  labels_number: 0,
  catalogPageNumber: 0,
  features: [
    FEATURES.analytics,
    FEATURES.customLabelDesign,
    FEATURES.whiteLabel,
    FEATURES.import,
    FEATURES.catalogPages,
  ],
};

export const FREE_PLAN = {
  name: Plans.values.free,
  price: 0,
  producersNumber: 1,
  labels_number: 3,
  catalogPageNumber: 0,
  features: [],
};

export const PLANS_TIERS = [
  {
    name: Plans.values.starter,
    producersNumber: 2,
    catalogPageNumber: 2,
    labels_number: 40,
    features: [FEATURES.analytics, FEATURES.import, FEATURES.catalogPages],
  },
  {
    name: Plans.values.basic,
    producersNumber: 3,
    catalogPageNumber: 3,
    labels_number: 100,
    features: [
      FEATURES.analytics,
      FEATURES.import,
      FEATURES.whiteLabel,
      FEATURES.catalogPages,
    ],
  },
  {
    name: Plans.values.standard,
    producersNumber: 3,
    catalogPageNumber: 5,
    labels_number: 150,
    features: [
      FEATURES.analytics,
      FEATURES.import,
      FEATURES.whiteLabel,
      FEATURES.customLabelDesign,
      FEATURES.catalogPages,
    ],
  },
  {
    name: Plans.values.plus,
    producersNumber: 5,
    catalogPageNumber: 10,
    labels_number: 400,
    features: [
      FEATURES.analytics,
      FEATURES.import,
      FEATURES.qrCode,
      FEATURES.whiteLabel,
      FEATURES.customLabelDesign,
      FEATURES.catalogPages,
    ],
  },
];

export const isWhiteLabelingEnabled = planName => {
  return [Plans.values.plus, Plans.values.pro].includes(planName);
};

export const calcIncludedCatalogPages = (quantity: number): number => {
  const q = quantity || 0;
  if (q <= FREE_PLAN.labels_number) {
    return FREE_PLAN.catalogPageNumber;
  }
  const sortedTiers = [...PLANS_TIERS].sort(
    (a, b) => b.labels_number - a.labels_number,
  );
  const refTier =
    sortedTiers.find(t => t.labels_number <= q) ??
    sortedTiers[sortedTiers.length - 1];
  const ratio = refTier.catalogPageNumber / refTier.labels_number;
  return Math.max(1, Math.floor(q * ratio));
};

export default Plans;
